/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, lines: NonNullable<unknown> }} Planshare_Active_MetaInputs */

const en_us2_planshare_active_meta = /** @type {(inputs: Planshare_Active_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workouts: ${i?.days} · Exercises: ${i?.lines}`)
};

const pt_br2_planshare_active_meta = /** @type {(inputs: Planshare_Active_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treinos: ${i?.days} · Exercícios: ${i?.lines}`)
};

const pt_pt2_planshare_active_meta = /** @type {(inputs: Planshare_Active_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treinos: ${i?.days} · Exercícios: ${i?.lines}`)
};

/** @type {(inputs: Planshare_Active_MetaInputs) => LocalizedString} */
const es_419_planshare_active_meta = en_us2_planshare_active_meta;

/** @type {(inputs: Planshare_Active_MetaInputs) => LocalizedString} */
const fr_fr2_planshare_active_meta = en_us2_planshare_active_meta;

/** @type {(inputs: Planshare_Active_MetaInputs) => LocalizedString} */
const de_de2_planshare_active_meta = en_us2_planshare_active_meta;

/** @type {(inputs: Planshare_Active_MetaInputs) => LocalizedString} */
const it_it2_planshare_active_meta = en_us2_planshare_active_meta;

/**
* | output |
* | --- |
* | "Workouts: {days} · Exercises: {lines}" |
*
* @param {Planshare_Active_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_active_meta = /** @type {((inputs: Planshare_Active_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_Active_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_active_meta(inputs)
	if (locale === "es-419") return es_419_planshare_active_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_active_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_active_meta(inputs)
	if (locale === "de-DE") return de_de2_planshare_active_meta(inputs)
	if (locale === "it-IT") return it_it2_planshare_active_meta(inputs)
	return en_us2_planshare_active_meta(inputs)
});
export { planshare_active_meta as "planshare.active_meta" }